document.addEventListener('DOMContentLoaded', () => {
  const groups = [...document.querySelectorAll('.nz-category')];
  groups.forEach(group => {
    group.addEventListener('toggle', () => {
      if (!group.open) return;
      groups.forEach(other => { if (other !== group && other.parentElement === group.parentElement) other.open = false; });
    });
    group.addEventListener('keydown', event => {
      if (event.key === 'Escape' && group.open) {
        event.preventDefault();
        event.stopPropagation();
        group.open = false;
        group.querySelector('summary').focus();
      }
    });
    group.addEventListener('focusout', () => {
      requestAnimationFrame(() => { if (!group.contains(document.activeElement)) group.open = false; });
    });
    group.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { group.open = false; }));
  });
  document.addEventListener('pointerdown', event => {
    groups.forEach(group => { if (group.open && !group.contains(event.target)) group.open = false; });
  });
});
